import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { PillBadges } from "../../../../DataDisplay/PillBadges/index.js";
import { MemberOnlyItemBadge } from "./components/MemberOnlyItemBadge/index.js";
import { ProductDeliveryBadgeAddtoList } from "./components/ProductDeliveryBadgeAddtoList/index.js";
import { childElementStyles } from "./styles.js";
const ProgramsBlock = ({
  pillBadges,
  isFsaEligible,
  isMemberOnlyItem,
  partNumber,
  pdpNavigationUrl
}) => {
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        flex: 1,
        flexDirection: "column",
        gap: SpaceXxs,
        zIndex: 1
      },
      children: [
        pillBadges && pillBadges.length > 0 && /* @__PURE__ */ jsx(
          PillBadges,
          {
            sx: {
              ...childElementStyles,
              gap: SpaceXxs,
              width: "100%"
            },
            dataPrivate: isFsaEligible,
            pillBadges,
            uniqueId: partNumber
          }
        ),
        isMemberOnlyItem && /* @__PURE__ */ jsx(
          MemberOnlyItemBadge,
          {
            pdpNavigationUrl,
            uniqueId: partNumber
          }
        ),
        /* @__PURE__ */ jsx(ProductDeliveryBadgeAddtoList, {})
      ]
    }
  );
};
export {
  ProgramsBlock
};
